
<template>
  <div>
    <conditions-element v-bind:showadvanced="true" v-bind:showadd="true" ref="procedureSchConditions" @change="conditionsChanged"></conditions-element>
  </div>
</template>

<script>
  export default {
    name: 'conditions-editor',
    components: {
    },
    props: {

    },
    methods:
    {
      conditionsChanged() {
        this.$emit("change")
      },
      setData(data) {
        //alert("setData")
        this.$refs.procedureSchConditions.setData(data)
      },
      getJsonData() {
        //return this.$refs.procedureSchConditions.getJsonData();
      },
      handleRefresh() {
        var conditions = this.procedure.Settings.Conditions;
        this.setData(conditions);
        this.$forceUpdate();
      }

    },
    computed: {
      elements: {
        get() {
          var proc = this.procedure;
          var els = this.getFlat(proc.Elements);
          return els;
        },
      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 2");
          this.$store.commit('saveprocedure', value)
        }
      },
    },
    created() {
      
    },
    mounted() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
      this.$root.$on('procedure_loaded', this.handleRefresh);
      
    },
}
</script>



// WEBPACK FOOTER //
// src/components/conditions/conditions-editor.vue